enum EstadoCumplimientoPedido {
  Planeados = 1,
  ProximosAVencer = 2,
  Atrasados = 3,
}

export default EstadoCumplimientoPedido;
